import templateUrl from './role-list.component.html';

const defaultSortField = "Name";
export const RoleListComponent = {
    templateUrl,
    controller: class RolesController {
        constructor(utilityService, roleService, $state) {
            'ngInject'

            this.utilityService = utilityService;
            this.roleService = roleService;
            this.$state = $state;
            this.sortColumns = [];
            this.filters = {};
        }

        $onInit() {
            this.onSetSort(defaultSortField);
        }

        $onChanges(changesObj) {
            if (changesObj.roleList) {
                // Update filter and sort order.
                this.filteredRoleList = this.roleList.filter(role => this.filterRoleList(role));
                if (this.sortField) {
                    this.sortRoles(this.filteredRoleList);
                }
            }
        }

        onChangeFilters() {
            this.filteredRoleList = this.roleList
                .filter(role => this.filterRoleList(role));
            if (this.sortField) {
                this.sortRoles(this.filteredRoleList);
            }
        }

        filterRoleList(role) {
            return (!this.filters.Name || this.utilityService.containsInvariant(role.Name,
                this.filters.Name))
                && (!this.filters.TranslatedDescription || this.utilityService.containsInvariant(
                    role.TranslatedDescription, this.filters.TranslatedDescription))
                && (!this.filters.GrantType || this.utilityService.containsInvariant(role.GrantType,
                    this.filters.GrantType))
                && (!this.filters.Scope || this.utilityService.containsInvariant(role.Scope,
                    this.filters.Scope))
                && (!this.filters.MinPositionsFilled || this.utilityService.containsInvariant(role.MinPositionsFilled,
                    this.filters.MinPositionsFilled))
                && (!this.filters.MaxPositionsFilled || this.utilityService.containsInvariant(role.MaxPositionsFilled,
                    this.filters.MaxPositionsFilled))
                && (!this.filters.isProtected || this.utilityService.containsInvariant(role.isProtected,
                    this.filters.isProtected))
        }

        onSetSort(sortField) {
            let sortColumn = this.sortColumns.filter((sortColumn) => {
                return sortColumn.field === sortField;
            })[0];
            if (!sortColumn) {
                // Start dir at -1 (descending) so that it toggles to ascending order by default.
                sortColumn = { field: sortField, dir: -1 };
                this.sortColumns.splice(0, this.sortColumns.length);
                this.sortColumns.unshift(sortColumn);
            }
            sortColumn.dir *= -1;
            this.sortField = sortField;
            this.sortRoles(this.filteredRoleList);
        }

        loadRoles() {
            this.$state.reload();
        }

        sortRoles(roles) {
            return roles.sort((a, b) => {
                return this.sortColumns.reduce((comparison, column) => {
                    // Go through all columns in order and return the value
                    // of the first comparison that broke equality (ie, returned non-0).
                    if (comparison === 0) {
                        // Still equal.
                        if (a[column.field] < b[column.field]) {
                            return -1 * column.dir;
                        } else if (a[column.field] > b[column.field]) {
                            return column.dir;
                        }
                    }
                    return comparison;
                }, 0);
            })
        }

        isSortingByField(field) {
            return this.sortField === field;
        }

        columnClass(field) {
            const column = this.getColumn(field);
            if (!column) {
                return {};
            }

            return {
                'glyphicon fas fa-sort-amount-down-alt': column.dir > 0,
                'glyphicon fas fa-sort-amount-down': column.dir < 0
            };
        }

        getColumn(field) {
            return this.sortColumns.filter(function (column) {
                return column.field === field;
            })[0];
        }

        onDelete(role) {
            if (!confirm("The role will be deleted. This will not affect assigned users until the next time they are edited for more changes.")) {
                return;
            }
            this.utilityService.showLoading();
            this.roleService.deleteRoleV2(role.RoleID)
                .then(() => {
                    this.$state.reload();
                }).catch((ex) => {
                    alert("Delete failed: " + this.utilityService.getExceptionMessage(ex));
                    this.utilityService.hideLoading();
                })
                .then(() => {
                    this.utilityService.hideLoading();
                });

        }
    },
    controllerAs: "vm",
    bindings: {
        roleList: "<"
    }
};
